// import library
import { useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { env } from "../../env";

const ResetPassword = () => {
    // variables
    const [errors, setErrors] = useState({});
    const [focuField, setFocusField] = useState('none');
    const [showNewPasssword, setShowNewPasssword] = useState(false);
    const [showCnfPasssword, setShowCnfPasssword] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const errorStyle = "text-danger-normal font-bold text-xs mt-0.5";
    const [inputs, setInputs] = useState({
        newPassword: "",
        cnfNewPassword: "",
    });

    // functions
    const validateValues = (inputValues) => {
        let errors = {};
        if (inputValues.newPassword.trim().length < 8) {
            errors.newPassword = true;
        }
        if (inputValues.cnfNewPassword.trim().length < 8) {
            errors.cnfNewPassword = true;
        }
        return errors;
    };
    const handleChange = (e) => {
        setInputs({
            ...inputs,
            [e.target.name]: e.target.value
        });
    }
    const handleFocus = (e, name) => {
        e.preventDefault();
        setFocusField(name);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setFocusField('none');
        setErrors(validateValues(inputs));

        if (Object.keys(validateValues(inputs)).length === 0) {
            const authData = {
                newPassword: inputs.newPassword,
                cnfNewPassword: inputs.cnfNewPassword
            };
            const baseUrl = env.REACT_APP_API_URL;
            const headers = {
                "Content-Type" : "multipart/form-data"
            };

            axios.post(baseUrl+"/api/user/ResetUserPassword", authData, { headers })
            .then((response) => {
                console.log(response);
            }).catch((error) => {
                console.log(error);
            });
        }
    }
    
    return (
        <div className="relative max-w-md sm:max-w-full">
            <div className="bg-auth-light flex flex-col items-center justify-center min-h-screen top-0 h-full">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="bg-white p-12 rounded-3xl w-[560px]">
                        <div className="space-y-6">
                            <h1 className="text-center font-bold text-3xl">Reset Password</h1>
                            <div className="text-light-400 text-center">Create new password for your account</div>
                            <div className="space-y-4">
                                <div>
                                    <div className={(focuField === 'new' ? 'border-blue-normal' : 'border-light-100') + " flex border rounded-lg p-3 items-center"}>
                                        <img className="mr-2" src={`../../../assets/icons/auth/new.svg`} />
                                        <input onFocus={(e) => handleFocus(e, 'new')} name="newPassword" type={showNewPasssword ? "text" : "password"} value={inputs.newPassword} onChange={(e) => handleChange(e)} className="border-none focus:outline-none w-full placeholder:text-gray-dark" placeholder="Enter New Password" />
                                        <img onClick={(e) => setShowNewPasssword(!showNewPasssword)} className="cursor-pointer" src={`../../../assets/icons/auth/${showNewPasssword ? "show" : "hide"}.svg`} />
                                    </div>
                                    {errors.newPassword ? (
                                        <p className={errorStyle}>
                                            Password must be more than 8 character !!
                                        </p>
                                    ) : null}
                                </div>
                                <div>
                                    <div className={(focuField === 'confirm' ? 'border-blue-normal' : 'border-light-100') + " flex border rounded-lg p-3 items-center"}>
                                        <img className="mr-2" src={`../../../assets/icons/auth/confirm.svg`} />
                                        <input onFocus={(e) => handleFocus(e, 'confirm')} className="border-none focus:outline-none w-full" name="cnfNewPassword" type={showCnfPasssword ? "text" : "password"} value={inputs.cnfNewPassword} onChange={(e) => handleChange(e)} placeholder="Confirm New Password" />
                                        <img onClick={(e) => setShowCnfPasssword(!showCnfPasssword)} className="cursor-pointer" src={`../../../assets/icons/auth/${showCnfPasssword ? "show" : "hide"}.svg`} />
                                    </div>
                                    {errors.cnfNewPassword ? (
                                        <p className={errorStyle}>
                                            Confirm Passowrd must be more than 8 character!!
                                        </p>
                                    ) : null}
                                </div>
                            </div>
                            <div>
                                <button type="submit" className="font-semibold text-white bg-blue-normal border-blue-normal rounded-lg text-center w-full py-3 px-2 cursor-pointer tracking-wide">
                                    Reset Password
                                </button>
                            </div>
                            <div className="font-semibold text-blue-normal bg-white text-center w-full cursor-pointer tracking-wide">
                                <NavLink to="/">
                                    Cancel & Go back
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {showModal ? 
                <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 right-0">
                    <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-900 opacity-75" />
                        </div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            <div className="bg-white p-6 space-y-5">
                                <div className="flex justify-between items-center">
                                    <div className="font-bold text-2xl">Password Reset Successfully</div>
                                    <div className="cursor-pointer" onClick={(e) => setShowModal(!showModal)}>
                                        <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                    </div>
                                </div>
                                <div className="text-light-400 text-lg">
                                    Your password has been successfully reset. You can now log in with your new password. 
                                </div>
                                <div className="text-right">
                                    <NavLink to="/forgot-password" className="font-semibold text-white bg-blue-normal border-blue-normal rounded-lg text-center w-full px-6 py-3 cursor-pointer tracking-wide">
                                        Login
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            : null }
        </div>
    )
}

export default ResetPassword;